export default __webpack_public_path__ + "static/media/cover.bd45a10e.jpg";